<template>
  <div class="audio-player cx-div">
    <audio style="width: 100%" controls autoplay
      :src="getMediaHost(audio, 'MGTO')"
      ref="player"
    ></audio>
  </div>
</template>

<script>
export default {
  name: 'audio-player',
  props: {
    audio: {
      type: String,
      default: "",
    }
  },
}
</script>

<style lang="scss">
.audio-player{
  padding-top: $space-base;
}
</style>
